import { message } from 'antd';
import { FormInstance } from 'antd/lib/form';
import coursesApiClient from 'utils/coursesApiClient';
import { useIntl } from 'react-intl';
import FileDownload from 'js-file-download';

interface UseMaterialProps {
  courseId: number;
  activityId: number;
  form: FormInstance;
  fileTitle?: string;
  fileType?: string;
}

export const useMaterial = ({
  courseId,
  activityId,
  form,
  fileTitle,
  fileType
}: UseMaterialProps) => {
  const intl = useIntl();

  const downloadFile = async () => {

    try {
      const version = form.getFieldValue('version');

      if (!version) {
        message.error(intl.formatMessage({ id: 'error.select_version' }));
        return;
      }

      const response = await coursesApiClient.request(
        `/api/v1/courses/${courseId}/activities/${activityId}/material/download/${version}?file_type=${fileType}`,
        null,
        'GET',
        true,
        true
      );

      const fileExtension = fileType === 'PDF_MATERIAL' ? 'pdf' : 'zip';

      FileDownload(response, fileTitle ? `${fileTitle}.${fileExtension}` : `material.${fileExtension}`);
    } catch (error) {
      message.error(intl.formatMessage({ id: 'error.download_failed' }));
    }
  };

  return {
    downloadFile,
  };
};